import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, FormStore, inject, Input, Loader, Nullable } from 'Mri.Web.Common';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Button, Form, FormGroup } from 'reactstrap';
import { AppStore } from '../../../Core/AppStore';
import { DisplayConfigurationStore } from './DisplayConfigurationStore';

export interface IDisplayConfigurationViewParams {
    readonly serialNumber: string;
}

export interface IDisplayConfigurationProps extends RouteComponentProps<IDisplayConfigurationViewParams> {}

@autoinject
@observer
export class DisplayConfiguration extends React.Component<IDisplayConfigurationProps> {
    @action
    public async componentDidMount() {
        this.loading = true;
        try {
            await this.displayConfigurationStore.loadAsync(this.props.match.params.serialNumber);

            this.fillForm();
        } catch (e: any) {
            this.appStore.setError(e);
        } finally {
            this.loading = false;
        }
    }

    public render() {
        return (
            <div className="container-fluid px-2 px-md-4">
                <Form onSubmit={this.submitAsync}>
                    <div className="row flex-items-center">
                        <div className="col-md-4 py-2">
                            <h5>Configured Time Zone:</h5>
                        </div>
                        <div className="col-md-8">
                            {this.displayConfigurationForm && (
                                <FormGroup color={this.displayConfigurationForm.fields.timeConfiguration.state}>
                                    <Input
                                        type="text"
                                        field={this.displayConfigurationForm.fields.timeConfiguration}
                                        placeholder="Timezone"
                                        disabled
                                        required
                                    />
                                </FormGroup>
                            )}
                        </div>

                        {/*<div className="col-12 text-center">
                            <FormGroup>
                                <Button type="submit" color="primary" disabled={this.loading}>
                                    <Loader loading={this.loading} showSpinner message="Applying..." />
                                    {!this.loading && <span>Update</span>}
                                </Button>
                            </FormGroup>
                        </div>*/}
                    </div>
                </Form>
            </div>
        );
    }

    @bind
    @action
    private async submitAsync(event: React.FormEvent<HTMLFormElement>) {
        if (!this.displayConfigurationForm) throw new Error('Form does not exist');

        event.preventDefault();
        this.displayConfigurationForm.onSubmit();

        if (this.displayConfigurationForm.validate()) {
            this.loading = true;

            try {
                await this.displayConfigurationStore.updateAsync(
                    this.props.match.params.serialNumber,
                    this.displayConfigurationForm.values
                );
            } catch (e: any) {
                if (e.modelState) {
                    this.displayConfigurationForm.clearGlobalErrors();
                    this.displayConfigurationForm.addErrors(e.modelState);
                } else {
                    console.error(e);
                }
            } finally {
                this.loading = false;
            }
        } else {
            console.log('invalid');
        }
    }

    @action
    private fillForm() {
        if (this.displayConfiguration) {
            this.displayConfigurationForm = new FormStore<Mri.DisplayConfigurations.DisplayConfiguration>(
                this.displayConfiguration
            );
        } else {
            const model: Nullable<Mri.DisplayConfigurations.DisplayConfiguration> = {
                displaySerialNumber: '',
                timeConfiguration: '',
                windowsTimeConfiguration: null,
                displayLoginPoll: null,
                displayConfigPoll: null,
            };

            this.displayConfigurationForm = new FormStore<Mri.DisplayConfigurations.DisplayConfiguration>(model);
        }
    }

    @computed
    private get displayConfiguration() {
        return this.displayConfigurationStore.displayConfigurations.get(this.props.match.params.serialNumber);
    }

    @observable
    private loading = false;
    @observable
    private displayConfigurationForm?: FormStore<Mri.DisplayConfigurations.DisplayConfiguration>;
    @inject
    private displayConfigurationStore!: DisplayConfigurationStore;
    @inject
    private appStore!: AppStore;
}
